import { AusPostIcon, InhouseParcelIcon } from "../components/Icon";

export const useGetCarrierImage = (courierName) => {
  if (courierName === "EPARCEL") {
    return <AusPostIcon width="25" height="25" />;
  }
  if (courierName === "MYFASTWAY") {
    return (
      <img src="https://vtlogo.com/wp-content/uploads/2021/02/fastway-couriers-vector-logo.png" width="30px" height="24px" />
    );
  }
  if (courierName === "DIRECTFREIGHT") {
    return <img src="https://www.directfreight.com.au/images/logo.gif" width="30px" height="24px" />;
  }
  if (courierName === "INHOUSE" || courierName === "AUSPOST") {
    return <InhouseParcelIcon />;
  }
};
